import React, { forwardRef } from 'react';


const Section = forwardRef(({ 
  id, 
  children, 
  className = '', 
  variant = 'default',
  ...props 
}, ref) => {
  const baseClasses = 'py-20 md:py-32 px-4 relative';
  
  const variants = {
    default: '',
    banded: 'bg-gradient-to-br from-dark-navy via-dark-navy/95 to-dark-navy',
    diagonal: 'bg-gradient-to-br from-dark-navy via-dark-navy to-gold/10',
  };

  return (
    <section 
      ref={ref}
      id={id} 
      className={`${baseClasses} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </section>
  );
});

Section.displayName = 'Section';

export default Section;

